module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ZZQfNu/tc-custom/9781685502027.jpg?1723406932734",
      "alt": "This image is the cover for the book Stage Fright"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Stage Fright\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("All the world's a stage, but Hell's Kitchen private detective Jimmy McSwain learns life upon its wicked boards can be a killer."), _c('br'), _c('br'), _vm._v("The Harold Calloway Theatre on West 47th Street is home to the new play "), _c('i', [_vm._v("Triskaidekaphobia")]), _vm._v(", and its playwright has been receiving threatening messages. Theatre owner and lead producer Wellington Calloway has hired Jimmy to investigate, but it's a case not without its complications. His mother is the head usher, and Jimmy grew up on its aisles. His ex Remy is also the costume designer for the show, a man he hasn't seen in years. Further making his life difficult is the mysterious Seetha Assan, who is connected -- albeit tentatively -- to the case that forever haunts Jimmy: his own father's murder. She may just have the clue to help him finally solve the cold case."), _c('br'), _c('br'), _vm._v("As opening night looms, Jimmy finds himself involved in a nest of egos and personalities while seeking the missing Seetha. Toss in his on-again, off-again relationship with Captain Francis X. Frisano, and suddenly Jimmy's life is edging toward tragedy. That's when a murderer strikes, and suddenly nothing is pretend anymore. Life on the stage has turned all too real, and all too deadly. Just like on the mean streets of Manhattan.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Adam Carpenter\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0